<template>
  <div :class="{'mb-2': marginBottom}">
    <span :class="{'d-sm-inline-block' : !lineBreak}" class="d-block text-primary mr-3">{{label}}</span>
    <a v-if="url" class="contact-detail-value" :href="url">{{ value }}</a>
    <span v-else class="contact-detail-value">{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: 'ContactDetailLine',
  props: {
    label: {
      type: String,
      required: true,
    },
    marginBottom: {
      type: Boolean,
      default: true,
    },
    lineBreak: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: '',
      required: true,
    },
    url: {
      type: String,
      default: null,
    },
  },
};
</script>
